import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
	ROOT_REDUCER_PATH,
	JOBS_FACETS_API,
	JOBS_LISTINGS_API,
	BASE_API_URL,
} from '@job-facets/utility/constants';
import TransformJobListings from '@job-facets/redux/transFormJobLists';

export const fetchApi = createApi({
	reducerPath: ROOT_REDUCER_PATH,
	baseQuery: fetchBaseQuery({
		baseUrl: BASE_API_URL,
	}),
	endpoints: (builder) => ({
		getJobsListings: builder.query({
			query: (args) => ({
				url: JOBS_LISTINGS_API,
				params: {
					...args,
				},
			}),
			transformResponse: (response) => {
				return TransformJobListings(response);
			},
		}),
		getJobsFacets: builder.query({
			query: () => ({
				url: JOBS_FACETS_API,
			}),
			transformResponse: (response) => {
				try {
					const {
						facets: {
							job_listing_type: jobListingType,
							job_listing_category: jobListingCategory,
							job_listing_tag: jobListingTag,
							job_listing_industry: jobListingIndustry,
							job_listing_company_size: jobListingCompanySize,
							is_remote_position:isRemotePosition,
							radius: { options: locationRadius },
						},
					} = response;

					return {
						facets: {
							jobListingType,
							jobListingCategory,
							jobListingCompanySize,
							jobListingIndustry,
							isRemotePosition
						},
						jobListingTag,
						locationRadius,
					};
				} catch (e) {
					// eslint-disable-next-line no-console
					console.error(e);
					return response;
				}
			},
		}),
	}),
});

export const { useGetJobsListingsQuery, useGetJobsFacetsQuery } = fetchApi;
